import React, { useMemo } from 'react'
import T from 'prop-types'

import CarDetails from '../CarDetails'
import CarDetailsPageTitle from '../CarDetails/CarDetailsPageTitle'
import CarBookedCarAdditionalDetails from '../CarsBooked/CarBookedCarAdditionalDetails'
import { getRepriceValues } from '../../../lib/repriceFee'

export default function CarsBookedCarDetails({ vin, cars, setShowDetails }) {
  const car = useMemo(() => cars.find((car) => car.vin === vin), [cars, vin])

  const repriceValues = car?.reprice
    ? getRepriceValues(car.reprice, car.feePercentage)
    : {}

  const priceNetToShow = car?.reprice ? repriceValues.repriceNet : car?.price
  const feeToShow = car?.reprice ? repriceValues.repriceFee : car?.fee

  return (
    <div data-testid="cars-booked-details">
      <CarDetailsPageTitle
        setShowDetails={setShowDetails}
        cars={cars}
        vin={vin}
      />
      {car && (
        <CarDetails
          car={car}
          price={priceNetToShow}
          fee={feeToShow}
          rightBottom={<CarBookedCarAdditionalDetails vertical car={car} />}
        />
      )}
    </div>
  )
}

CarsBookedCarDetails.propTypes = {
  vin: T.string.isRequired,
  session: T.object.isRequired,
  cars: T.array.isRequired,
}
